import { useCentralApi, useCurrentUser } from "hooks/shared";

type UseWorkItemWorkflowsExportSignature = 
(
    workitemId: number,
    workitemName: string
) => () => Promise<void>;

const useWorkItemWorkflowsExport : UseWorkItemWorkflowsExportSignature = (workitemId, workitemName) => {
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);
    const fileName = `Work Item - ${workitemName} (${workitemId}) - Workflows`;

    const handleExport = async () => {
        const resp = await fetcher(`/api/v3/workitems/${workitemId}/workflows/export`);

        const blob = new Blob([await resp.blob()], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    };

    return handleExport;
}

export default useWorkItemWorkflowsExport;